import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

// components
import { ShopVerticals } from './ShopVerticals/ShopVerticals';
import { Button } from 'dibs-elements/src/Button';

// helpers
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
const { DISCOVER_FEED_FLOW, REGISTER } = authModalLoader.constants;
import { showUserSurvey, shouldLaunchUserSurvey } from '../Discover/helpers/userSurvey';

// styles
import styles from './styles/AboutDiscoverContainer.scss';

const launchUserSurvey = ({ hasUserId, refetchDiscoverFeed }) => {
    if (hasUserId) {
        showUserSurvey().then(refetchDiscoverFeed);
    } else {
        authModalLoader
            .show({
                flow: DISCOVER_FEED_FLOW,
                action: REGISTER,
            })
            .then(authResult => {
                const authUserId = get(authResult, 'user.userId');
                if (authUserId) {
                    showUserSurvey().then(() => refetchDiscoverFeed({ authUserId }));
                }
            });
    }
};

export const AboutDiscoverContainer = ({ hasUserId, refetchDiscoverFeed }) => {
    useEffect(() => {
        if (shouldLaunchUserSurvey()) {
            launchUserSurvey({ hasUserId, refetchDiscoverFeed });
        }
    }, [hasUserId, refetchDiscoverFeed]);

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <FormattedMessage
                    id="discover.aboutDiscover.title"
                    defaultMessage="Get inspired!"
                />
            </div>
            <div className={styles.subtitle}>
                <FormattedMessage
                    id="discover.aboutDiscover.subtitle"
                    defaultMessage="Save items you love and follow what interests you, and we’ll serve up personalized 1stdibs content for you to explore. Get started by taking a quick survey to set your shopping preferences."
                />
            </div>
            <Button
                onClick={() => {
                    launchUserSurvey({ hasUserId, refetchDiscoverFeed });
                }}
            >
                <FormattedMessage id="discover.aboutDiscover.cta" defaultMessage="Take Survey" />
            </Button>
            <ShopVerticals />
        </div>
    );
};

AboutDiscoverContainer.propTypes = {
    hasUserId: PropTypes.bool,
    refetchDiscoverFeed: PropTypes.func.isRequired,
};
